module.exports = __webpack_public_path__ + "static/apulanta2-7d85ec21e9ddf20310a5ee36aa392f1a.jpg";